import React from "react";
import { Popover } from "@headlessui/react";
import { Link } from "wouter";
import HelpIcon from '@mui/icons-material/Help';
import CustomTooltipComponent from "../components/custom_tooltip_component";

const PopoverComponentCustom = ({ title }) => {
  return (
    <Popover as="header" className="bg-indigo-200">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-6 items-center py-4">
          <div></div>
          <h2 className="col-span-4 text-center text-2xl font-semibold text-indigo-800">
            {title}
          </h2>
          <div className="flex justify-end cursor-pointer">
            <a
              href="https://consultalahr.com/videoguida/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <CustomTooltipComponent title="Guida Utente" placement="left" arrow>
                <HelpIcon
                  className="inline-block text-indigo-700 flex me-1"
                  style={{ width: "30px", height: "30px" }}
                />
              </CustomTooltipComponent>
            </a>
          </div>
        </div>
      </div>
    </Popover>
  );
};


export default PopoverComponentCustom;
